import { RegistrationForms, RegistrationEmail, State } from './types';

const getters = {
  getRegistrationForms(state: State): RegistrationForms {
    return state.registrationForms;
  },
  getRegistrationEmail(state: State): RegistrationEmail {
    return state.registrationEmail;
  }
};

export default getters;
